<template>
  <v-row justify="center">
    <v-dialog
    fullscreen
    hide-overlay 
    v-if="dialog"
    v-model.sync="sDialog"
    >
      <v-card>
        <v-toolbar>
          <v-btn icon @click="sDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Detalhes do Lead</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-list three-line subheader>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Nome</v-list-item-title>
                <v-list-item-subtitle>{{lead.name}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Email</v-list-item-title>
                <v-list-item-subtitle>
                  {{lead.email}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>CPF/CNPJ</v-list-item-title>
                <v-list-item-subtitle>
                  {{lead.cpf_cnpj || '-'}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Telefone</v-list-item-title>
                <v-list-item-subtitle>
                  {{lead.phone || '-'}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>CEP</v-list-item-title>
                <v-list-item-subtitle>
                  {{lead.address && lead.address.postal_code || '-'}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Endereço</v-list-item-title>
                <v-list-item-subtitle>
                  {{lead.address && lead.address.address || '-'}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Bairro</v-list-item-title>
                <v-list-item-subtitle>
                  {{lead.address && lead.address.district || '-'}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Cidade/UF</v-list-item-title>
                <v-list-item-subtitle>
                  {{lead.address && lead.address.city && lead.address.city.name + '/' +lead.address.city.state.abbr  || '-'}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {

  name: 'Lead',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    lead: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    sDialog: {
      get() {
        return this.dialog;
      },
      set(value) {          
        this.$emit('closeDialog');
      }
    },
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="css" scoped>
</style>